import axios from "axios";
import { headersProvider } from "../apiHelpers";
import constants from "../constants";

export const sendEmail = ({ data }) =>
  axios.post(
    `${constants.apiHost}/emails/new/outgoing`,
    {
      ...data,
    },
    {
      headers: headersProvider(),
    },
  );

export const getEmailsApi = ({ page, parent, parentId }) =>
  axios.get(`${constants.apiHost}/emails/threads`, {
    params: {
      page,
      parent,
      parentId,
    },
    headers: headersProvider(),
  });

export const getEmailsFromThreadApi = ({ threadId, page }) =>
  axios.get(`${constants.apiHost}/emails/threads/${threadId}/emails`, {
    params: {
      page,
    },
    headers: headersProvider(),
  });

export const getEmailToApi = () =>
  axios.get(`${constants.apiHost}/emails/get-distinct-emailTo`, {
    headers: headersProvider(),
  });

export const getEmailCcApi = () =>
  axios.get(`${constants.apiHost}/emails/get-distinct-emailCc`, {
    headers: headersProvider(),
  });

export const getInboxEmails = ({ page, pageSize }) =>
  axios.post(
    `${constants.apiHost}/emails/inbox`,
    {
      page,
      pageSize,
    },
    {
      headers: headersProvider(),
    },
  );

export const getOutboxEmails = ({ page, pageSize }) =>
  axios.post(
    `${constants.apiHost}/emails/outbox`,
    {
      page,
      pageSize,
    },
    {
      headers: headersProvider(),
    },
  );
